"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerpackungFitsToConfigurationUtil = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_math_1 = require("@igus/echain-math");
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const echain_shared_configurations_1 = require("@igus/echain-shared-configurations");
class VerpackungFitsToConfigurationUtil {
    static verpackungFitsToConfiguration(verpackung, configuration, info = { input: {}, trace: [] }) {
        switch (verpackung.typ) {
            case echain_shared_articles_1.VerpackungType.karton:
                return VerpackungFitsToConfigurationUtil.kartonFitsToConfiguration(verpackung, configuration, info);
            case echain_shared_articles_1.VerpackungType.palette:
                return VerpackungFitsToConfigurationUtil.paletteFitsToConfiguration(verpackung, configuration, info);
            case echain_shared_articles_1.VerpackungType.trommel:
                return VerpackungFitsToConfigurationUtil.trommelFitsToConfiguration(verpackung, configuration, info);
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(verpackung.typ);
        }
    }
    static kartonFitsToConfiguration(verpackung, configuration, info = { input: {}, trace: [] }) {
        var _a, _b, _c;
        // input
        const kartonKerndurchmesser_mm = 0;
        let verpackungCalculationValues;
        const { type, config } = (0, echain_shared_configurations_1.asTypedConfigurationUnion)(configuration.toModel());
        switch (type) {
            case 'Empty': // nothing to pack
            case 'Espool': // no packaging calculation for e-spool
            case 'EspoolChild':
                return false;
            case 'Kette': {
                const ketteSerieType = config.Kette.KetteSerieType;
                switch (ketteSerieType) {
                    case echain_shared_articles_1.KetteSerieType.twisterband:
                        return false; // no packaging calculation for twiserband
                    case echain_shared_articles_1.KetteSerieType.default:
                    case echain_shared_articles_1.KetteSerieType.eskin:
                    case echain_shared_articles_1.KetteSerieType.triflexR:
                    case echain_shared_articles_1.KetteSerieType.trxe:
                    case echain_shared_articles_1.KetteSerieType.twisterchain:
                    case echain_shared_articles_1.KetteSerieType.rolEchain:
                    case echain_shared_articles_1.KetteSerieType.rxRohr:
                        break;
                    default:
                        (0, echain_shared_ts_utils_1.assertUnreachable)(ketteSerieType);
                }
                verpackungCalculationValues = {
                    ketteBiegeradius_mm: (_a = echain_shared_quantities_1.Q.optional(config.Kette.Biegeradius)) === null || _a === void 0 ? void 0 : _a.mm,
                    ketteAussenhoehe_mm: (_b = echain_shared_quantities_1.Q.optional(config.Kette.Aussenhoehe)) === null || _b === void 0 ? void 0 : _b.mm,
                    ketteEffektiveLaenge_mm: (_c = echain_shared_articles_oo_1.Kette.fromModel(config.Kette).getMostPreciseEffektiveLaenge()) === null || _c === void 0 ? void 0 : _c.mm,
                };
                break;
            }
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
        if (verpackungCalculationValues.ketteBiegeradius_mm == null ||
            verpackungCalculationValues.ketteAussenhoehe_mm == null ||
            verpackungCalculationValues.ketteEffektiveLaenge_mm == null) {
            return false;
        }
        // calc
        const ketteKerndurchmesser_mm = echain_math_1.VerpackungMath.calcKetteKerndurchmesser_mm(kartonKerndurchmesser_mm, verpackungCalculationValues.ketteBiegeradius_mm);
        const ketteWindungen_mm = echain_math_1.VerpackungMath.calcKetteWindungen(ketteKerndurchmesser_mm, verpackungCalculationValues.ketteAussenhoehe_mm, verpackungCalculationValues.ketteEffektiveLaenge_mm);
        const ketteAussendurchmesser_mm = echain_math_1.VerpackungMath.calcAussendurchmesserKetteForPalette_mm(ketteKerndurchmesser_mm, ketteWindungen_mm, verpackungCalculationValues.ketteAussenhoehe_mm);
        info.input = Object.assign(Object.assign({ kartonKerndurchmesser_mm }, verpackungCalculationValues), { ketteKerndurchmesser_mm,
            ketteWindungen_mm,
            ketteAussendurchmesser_mm });
        const ketteAussendurchmesserFitsInKarton = ketteAussendurchmesser_mm < 800;
        info.trace.push(`ketteAussendurchmesserFitsInKarton = ketteAussendurchmesser_mm < 800 = ${ketteAussendurchmesserFitsInKarton}`);
        info.output = ketteAussendurchmesserFitsInKarton;
        return info.output;
    }
    static paletteFitsToConfiguration(verpackung, configuration, info = { input: {}, trace: [] }) {
        var _a, _b, _c, _d;
        const paletteBreite_mm = verpackung.breite.mm;
        const paletteKerndurchmesser_mm = 0;
        let verpackungCalculationValues;
        const { type, config } = (0, echain_shared_configurations_1.asTypedConfigurationUnion)(configuration.toModel());
        switch (type) {
            case 'Empty': // nothing to pack
            case 'Espool': // no packaging calculation for e-spool
            case 'EspoolChild':
                return false;
            case 'Kette': {
                const ketteSerieType = config.Kette.KetteSerieType;
                switch (ketteSerieType) {
                    case echain_shared_articles_1.KetteSerieType.default:
                    case echain_shared_articles_1.KetteSerieType.eskin:
                    case echain_shared_articles_1.KetteSerieType.triflexR:
                    case echain_shared_articles_1.KetteSerieType.trxe:
                    case echain_shared_articles_1.KetteSerieType.twisterchain:
                    case echain_shared_articles_1.KetteSerieType.rolEchain:
                    case echain_shared_articles_1.KetteSerieType.rxRohr:
                        break;
                    case echain_shared_articles_1.KetteSerieType.twisterband:
                        return false; // no packaging calculation for twiserband
                    default:
                        (0, echain_shared_ts_utils_1.assertUnreachable)(ketteSerieType);
                }
                verpackungCalculationValues = {
                    ketteBiegeradius_mm: (_a = echain_shared_quantities_1.Q.optional(config.Kette.Biegeradius)) === null || _a === void 0 ? void 0 : _a.mm,
                    ketteAussenhoehe_mm: (_b = echain_shared_quantities_1.Q.optional(config.Kette.Aussenhoehe)) === null || _b === void 0 ? void 0 : _b.mm,
                    ketteAussenbreite_mm: (_c = echain_shared_quantities_1.Q.optional(config.Kette.Aussenbreite)) === null || _c === void 0 ? void 0 : _c.mm,
                    ketteEffektiveLaenge_mm: (_d = echain_shared_articles_oo_1.Kette.fromModel(config.Kette).getMostPreciseEffektiveLaenge()) === null || _d === void 0 ? void 0 : _d.mm,
                };
                break;
            }
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
        if (verpackungCalculationValues.ketteBiegeradius_mm == null ||
            verpackungCalculationValues.ketteAussenhoehe_mm == null ||
            verpackungCalculationValues.ketteAussenbreite_mm == null ||
            verpackungCalculationValues.ketteEffektiveLaenge_mm == null) {
            return false;
        }
        // calc
        const ketteKerndurchmesser_mm = echain_math_1.VerpackungMath.calcKetteKerndurchmesser_mm(paletteKerndurchmesser_mm, verpackungCalculationValues.ketteBiegeradius_mm);
        const ketteWindungen_mm = echain_math_1.VerpackungMath.calcKetteWindungen(ketteKerndurchmesser_mm, verpackungCalculationValues.ketteAussenhoehe_mm, verpackungCalculationValues.ketteEffektiveLaenge_mm);
        const ketteAussendurchmesser_mm = echain_math_1.VerpackungMath.calcAussendurchmesserKetteForPalette_mm(ketteKerndurchmesser_mm, ketteWindungen_mm, verpackungCalculationValues.ketteAussenhoehe_mm);
        info.input = Object.assign(Object.assign({ paletteBreite_mm,
            paletteKerndurchmesser_mm }, verpackungCalculationValues), { ketteKerndurchmesser_mm,
            ketteWindungen_mm,
            ketteAussendurchmesser_mm });
        const ketteNotTooLong = verpackungCalculationValues.ketteEffektiveLaenge_mm <= 20000 ||
            verpackungCalculationValues.ketteAussenbreite_mm <= 150;
        info.trace.push(`ketteNotTooLong = ketteEffektiveLaenge_mm <= 20000 || ketteAussenbreite_mm <= 150 = ${ketteNotTooLong}`);
        const ketteAussendurchmesserFitsToPaletteBreite = ketteAussendurchmesser_mm <= paletteBreite_mm;
        info.trace.push(`ketteAussendurchmesserFitsToPaletteBreite = ketteAussendurchmesser_mm <= paletteBreite_mm = ${ketteAussendurchmesserFitsToPaletteBreite}`);
        info.output = ketteNotTooLong && ketteAussendurchmesserFitsToPaletteBreite;
        return info.output;
    }
    static trommelFitsToConfiguration(verpackung, configuration, info = { input: {}, trace: [] }) {
        var _a, _b, _c, _d;
        // input
        let verpackungCalculationValues;
        const { type, config } = (0, echain_shared_configurations_1.asTypedConfigurationUnion)(configuration.toModel());
        const configurationGesamtgewicht_g = configuration.getWeightExceptVerpackungRinneAndMontageSet().g;
        const trommelBelastungMax_g = verpackung.trommelbelastungMax.g;
        const trommelKerndurchmesser_mm = verpackung.kerndurchmesser.mm;
        const trommelFlanschdurchmesser_mm = verpackung.flanschdurchmesser.mm;
        const trommelInnenbreite_mm = verpackung.innenbreite.mm;
        switch (type) {
            case 'Empty': // nothing to pack
            case 'Espool': // no packaging calculation for e-spool
            case 'EspoolChild':
                return false;
            case 'Kette': {
                const ketteSerieType = config.Kette.KetteSerieType;
                switch (ketteSerieType) {
                    case echain_shared_articles_1.KetteSerieType.default:
                    case echain_shared_articles_1.KetteSerieType.eskin:
                    case echain_shared_articles_1.KetteSerieType.triflexR:
                    case echain_shared_articles_1.KetteSerieType.trxe:
                    case echain_shared_articles_1.KetteSerieType.twisterchain:
                    case echain_shared_articles_1.KetteSerieType.rolEchain:
                    case echain_shared_articles_1.KetteSerieType.rxRohr:
                        break;
                    case echain_shared_articles_1.KetteSerieType.twisterband:
                        return false; // no packaging calculation for twiserband
                    default:
                        (0, echain_shared_ts_utils_1.assertUnreachable)(ketteSerieType);
                }
                verpackungCalculationValues = {
                    ketteBiegeradius_mm: (_a = echain_shared_quantities_1.Q.optional(config.Kette.Biegeradius)) === null || _a === void 0 ? void 0 : _a.mm,
                    ketteAussenhoehe_mm: (_b = echain_shared_quantities_1.Q.optional(config.Kette.Aussenhoehe)) === null || _b === void 0 ? void 0 : _b.mm,
                    ketteAussenbreite_mm: (_c = echain_shared_quantities_1.Q.optional(config.Kette.Aussenbreite)) === null || _c === void 0 ? void 0 : _c.mm,
                    ketteEffektiveLaenge_mm: (_d = echain_shared_articles_oo_1.Kette.fromModel(config.Kette).getMostPreciseEffektiveLaenge()) === null || _d === void 0 ? void 0 : _d.mm,
                };
                break;
            }
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
        if (verpackungCalculationValues.ketteBiegeradius_mm == null ||
            verpackungCalculationValues.ketteAussenhoehe_mm == null ||
            verpackungCalculationValues.ketteAussenbreite_mm == null ||
            verpackungCalculationValues.ketteEffektiveLaenge_mm == null) {
            return false;
        }
        // calc
        const ketteKerndurchmesser_mm = echain_math_1.VerpackungMath.calcKetteKerndurchmesser_mm(trommelKerndurchmesser_mm, verpackungCalculationValues.ketteBiegeradius_mm);
        const ketteWindungen_mm = echain_math_1.VerpackungMath.calcKetteWindungen(ketteKerndurchmesser_mm, verpackungCalculationValues.ketteAussenhoehe_mm, verpackungCalculationValues.ketteEffektiveLaenge_mm);
        const ketteAussendurchmesser_mm = echain_math_1.VerpackungMath.calcAussendurchmesserKetteForTrommel_mm(ketteKerndurchmesser_mm, ketteWindungen_mm, verpackungCalculationValues.ketteAussenhoehe_mm);
        info.input = Object.assign(Object.assign({ configurationGesamtgewicht_g,
            trommelBelastungMax_g,
            trommelKerndurchmesser_mm,
            trommelFlanschdurchmesser_mm }, verpackungCalculationValues), { ketteKerndurchmesser_mm,
            ketteWindungen_mm,
            ketteAussendurchmesser_mm });
        const ketteAussenbreiteFitsToTrommelBreite = (verpackungCalculationValues.ketteAussenbreite_mm <= 300 && trommelInnenbreite_mm === 800) ||
            (verpackungCalculationValues.ketteAussenbreite_mm > 300 &&
                verpackungCalculationValues.ketteAussenbreite_mm <= 450 &&
                trommelInnenbreite_mm === 1200);
        info.trace.push(`ketteAussenbreiteFitsToTrommelBreite = (ketteAussenbreite_mm <= 300 && trommelInnenbreite_mm === 700) || (ketteAussenbreite_mm > 300 && ketteAussenbreite_mm <= 450 && trommelInnenbreite_mm === 1200) = ${ketteAussenbreiteFitsToTrommelBreite}`);
        const ketteAussendurchmesserFitsOntoTrommel = ketteAussendurchmesser_mm <= trommelFlanschdurchmesser_mm;
        info.trace.push(`ketteAussendurchmesserFitsOntoTrommel = ketteAussendurchmesser_mm <= trommelFlanschdurchmesser_mm = ${ketteAussendurchmesserFitsOntoTrommel}`);
        const configurationGesamtgewichtFitsToTrommel = configurationGesamtgewicht_g <= trommelBelastungMax_g;
        info.trace.push(`configurationGesamtgewichtFitsToTrommel = configurationGesamtgewicht_g <= trommelBelastungMax_g = ${configurationGesamtgewichtFitsToTrommel}`);
        info.output =
            ketteAussenbreiteFitsToTrommelBreite &&
                ketteAussendurchmesserFitsOntoTrommel &&
                configurationGesamtgewichtFitsToTrommel;
        return info.output;
    }
}
exports.VerpackungFitsToConfigurationUtil = VerpackungFitsToConfigurationUtil;
//# sourceMappingURL=VerpackungFitsToConfigurationUtil.js.map